// eslint-disable-next-line
import { UntypedFormControl } from '@angular/forms';

import { DragAndDropInfoDto } from '@treetop/shared/model';

import { EnumItem } from './util-enum-resolver';

export const LANG = 'lang';
export const TOKEN = 'access_token';
export const LOADING_RULE = '!!!loading-!!!-rule!!!';
export const MAX_CHAPTER_LEVELS = 4;

export class FlowChartData {
  key?: string;
  group?: string;
  title?: string;
  color?: string;
  strokeColor?: string;
  textColor?: string;
  imgSource?: string;
  category?: string;
  isPreferredOption?: boolean;
  isGroup?: boolean;
  isGroupVisible?: boolean;
  groupPadding?: number;
  selectionBehaviorValue?: string;
  selectionBehaviorWidth?: number;
  selectionBehaviorHeight?: number;
  isChild?: boolean;
  iconType?: FlowchartNodeIconType;
  iconSourceRecurrence?: string;
  iconSourceStopCondition?: string;
  iconSourceFollowUp?: string;
  isRecurrenceVisible?: boolean;
  isStopConditionVisible?: boolean;
  isFollowUpVisible?: boolean;
}

export class FlowChartContainerData extends FlowChartData {
  subtitle: string;
  items: string[];
}

export enum FlowchartNodeIconType {
  Information = 'information',
  Code = 'code',
  None = 'none',
}

export enum SelectionBehaviorNodes {
  Siblings = '-siblings',
  Children = '-round-node',
  Link = '-round-link',
}

export enum TreeType {
  definition = 'definition',
  template = 'template',
  guideline = 'guideline',
  smartbook = 'smartbook',
}

export interface Asset {
  readonly file: File;
  readonly name: string;
  readonly id?: string;
}

export class SearchOptions {
  page?: number;
  itemsPerPage?: number;
  field?: string;
  order?: string;
  languageCode?: string;
}

export enum ShortType {
  ActivityDefinition = 'AD',
  ConditionDefinition = 'CD',
  FindingDefinition = 'FD',
  ObservationDefinition = 'OD',
  CodeableConcept = 'VS',
  CodeableConceptValue = 'VSV',
  Guideline = 'GL',
  Template = 'TL',
}

export enum DialogDataType {
  input = 'input',
  select = 'select',
  texteditor = 'texteditor',
  rule = 'rule',
}

export enum GuidelineDialogType {
  Attachment = 1,
}

export interface DialogData {
  name: string;
  control: UntypedFormControl;
  templateControl: UntypedFormControl;
  inputType: DialogDataType;
  selectData?: EnumItem[];
}

export interface SmartbookInfoItem {
  key: string;
  value: string;
  isRule?: boolean;
  isUcum?: boolean;
}

export interface SmartbookInfoGroup {
  items: SmartbookInfoItem[];
}

export interface ActivityDefinitionFormControls {
  priority?: UntypedFormControl;
  significance?: UntypedFormControl;
}

export const initalUniqueId = '00000000-0000-0000-0000-000000000000';

export const allowedAttachmentTypes = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.bmp',
  '.tif',
  '.svg',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.pdf',
  '.mp4',
  '.avi',
  '.wmv',
  '.mpg',
  '.mpeg',
  '.mp3',
  '.zip',
  '.epub',
];

export interface Resources {
  availableResources: DragAndDropInfoDto[];
  attachedResources: DragAndDropInfoDto[];
  deletedImportedResourceIds?: string[];
}
